<div *ngIf="!isLoading">
  <div class="btn-list">
    <div class="btn-icon" *ngIf="projeto.permissions.edit">
      <a [routerLink]="editar()">
        <img src="assets/images/svgs/Editar.svg" alt="Editar" tooltip="Editar" placement="bottom">
      </a>
    </div>
    <button type="button" class="btn-back" (click)="voltar()">Voltar</button>
  </div>

  <div class="info-page">
    <h3>Projeto Agregador</h3>
  </div>

  <div class="list-info">
    <h4>Projeto Agregador:</h4>
    <p class="destaque">{{ projeto?.title }}</p>
  </div>

  <div class="list-info">
    <h4>Descrição:</h4>
    <p>{{ projeto?.description }}</p>
  </div>

  <div class="list-info">
    <h4>Órgão responsável:</h4>
    <p>{{ projeto?.agency?.name }}</p>
  </div>

  <div class="list-info">
    <h4>Gerente:</h4>
    <p>{{ projeto?.manager?.name }}</p>
  </div>

  <div class="list-info">
    <h4>Gerente Adjunto:</h4>
    <p>
      <span *ngFor="let item of projeto?.manager_adjunct">{{item.name}}<br></span>
    </p>
  </div>

  <div class="list-info">
    <h4>Ativo:</h4>
    <p>{{ (projeto?.actived)? "SIM": "NÃO" }}</p>
  </div>

  <div class="list-info">
    <h4>Programa/Projeto agregador Pai:</h4>
    <p>{{ projeto?.program_pai?.name }}</p>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>
